import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EnvironmentServiceProvider } from "@webapp/env/providers/environment.provider";
import { PluginOnLoadDirective } from "@webapp/plugins/components/plugin/plugin-onload.directive";
import { PluginComponent } from "@webapp/plugins/components/plugin/plugin.component";
import { PluginsComponent } from "@webapp/plugins/components/plugins/plugins.component";
import { PluginsActionsProvider } from "@webapp/plugins/providers/plugins.provider";

@NgModule({
  imports: [CommonModule],
  declarations: [PluginComponent, PluginsComponent, PluginOnLoadDirective],
  exports: [PluginsComponent],
  providers: [EnvironmentServiceProvider, PluginsActionsProvider],
})
export class PluginsModule {}
